import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { getOrdersByDate } from "../ordersThunk";
import { OrdersResponce, OrdersState } from "../types";
import { CustomError } from "shared/api";
import { groupOrdersByDate } from "entities/orders/lib/helpers/manage/manageOrderState";

export const getOrderByDateReducer = (builder: ActionReducerMapBuilder<OrdersState>) => {
	builder
		.addCase(getOrdersByDate.pending, state => {
			state.loading = true;
			state.loadedTable = null;
			state.ordersByTable = [];
			state.loadingError = ''
		})
		.addCase(
			getOrdersByDate.fulfilled,
			(state, action: PayloadAction<OrdersResponce>) => {
				state.loading = false;
				const results = action.payload.results;

				const groupedOrders = groupOrdersByDate(results, state);

				state.ordersByDate = groupedOrders;
				state.error = null;
			},
		)
		.addCase(getOrdersByDate.rejected, (state, action) => {
			state.loading = false;
			state.loadingError = 'Произошла ошибка загрузки данных'
			state.error = action.payload as CustomError;
		})
}